export const CALL_VALUES = {
  VIDEO: 2,
  VOICE: 1,
  IN_PERSON: 3,
};

export const MEETING_RESPONSE = {
  CONFIRM: 1,
  DECLINE: 2,
  PENDING: 3,
};

export const WISTLEBLOWER = 1;

export interface MeetingDetailItemObject {
  id: number;
  name: string;
  organizer: string;
  reportType: {
    id: number;
    name: string;
    type: number;
  };
  country: string;
  date: string;
  link: string;
  type: number;
  address: string | null;
}

export const WEEKDAYS = {
  SUNDAY: 6,
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
};
